import { getResponsiveBreakpoint } from '../util/breakpoint';

// Only init this component when it's on the page
// TODO: only include this JS on the right page
var component = document.querySelector('.labels-explainer');
if (component) {
  init();
}

function init() {
  var breakpoint = getResponsiveBreakpoint();
  var circles = [].slice.call(
    document.querySelectorAll('.labels-explainer .interactive .center-point a')
  );
  var labelLinks = [].slice.call(
    document.querySelectorAll('.labels-explainer .label-link')
  );
  var labelInfoBoxes = [].slice.call(
    document.querySelectorAll('.labels-explainer .label-info')
  );

  var personImg = document.querySelector('.labels-explainer img.person');
  var personSrc = personImg.getAttribute('data-src');

  var didPickFirstLabel = false;

  var labelSlug = '';

  // Link clicks, both of the circles and the buttons in the info boxes on the right
  labelLinks.forEach(link => {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      didPickFirstLabel = true;
      labelSlug = event.target.getAttribute('href').replace('#', '');
      selectLabel(labelSlug);
      _paq.push([
        'trackEvent',
        'LabelExplainerClick',
        labelSlug,
        event.srcElement.classList[0],
      ]);
    });
  });

  // Move the circles on the right position based on the
  // selected circle + scales up the selected circle
  function highlightCircle(id) {
    var highlighted = circles.findIndex(
      circle => circle.getAttribute('href') === `#${id}`
    );
    // The lower circle the user selects the more extra rotation we give
    var extraRotation = (4 - highlighted) * 8;
    circles.forEach(function (circle, i) {
      var scale = 1;
      var offset = 0;
      if (didPickFirstLabel) {
        if (i === highlighted) {
          scale = 1.2;
        } else if (i < highlighted) {
          offset = -5;
        } else if (i > highlighted) {
          offset = 5;
        }
      }
      circle.style.transform = `rotate(${
        -45 + extraRotation + i * 40 + offset
      }deg) translate(-150px) scale(${scale}) rotate(${
        45 - extraRotation - i * 40 - offset
      }deg)`;
    });
    personImg.src = personSrc.replace('XXX', highlighted + 1);
  }

  function selectLabel(id) {
    // Scroll the whole component in view on mobile so that
    // it's clear how the two things relate
    if (breakpoint === 'xs' || breakpoint === 'sm') {
      component.scrollIntoView();
    }

    // This hides the pulse animation
    component.classList.remove('no-interaction');

    // Scale up and move the circles
    highlightCircle(id);

    // Make circle 'active', give it a border
    circles.forEach(circle => {
      if (circle.getAttribute('href') === `#${id}`)
        circle.classList.add('active');
      else circle.classList.remove('active');
    });

    // Make the right info box 'active'
    labelInfoBoxes.forEach(el => {
      if (id === el.id) el.classList.add('active');
      else el.classList.remove('active');
    });
  }
}
